<template>
  <div class="container">
    <div class="title"><span>首页</span>>  <span>推荐专家</span>> 专家详情</div>
    <div class="neir">
      <div class="l">
        <div class="t">
          <img :src="detail.hospitalExpert.picUrl" alt="">
          <div>
            <p class="name">{{detail.hospitalExpert.name}}</p>
            <p class="zc">主任医师</p>
            <p><span>所在科室：</span>肿瘤科</p>
            <p class="sc"><span>医生擅长：</span>{{detail.hospitalExpert.sellPoint}}</p>
            <!--<p><span>就职医院：</span>上海华东医院肿瘤科</p>-->
          </div>
        </div>
        <div class="divR">
          <!--<p>检查费用：7000元 </p>-->
          <!--<p> 医院等级：影像中心</p>-->
          <!--<p>设备型号：Siemens Biograph 64 HD </p>-->
          <!--<p>工作时间：周一~周五:8:00-16:30，周六:8:00-12:00</p>-->
          <!--<p>医院地址：北京市徐汇区桂林路406号华鑫中心8号楼</p>-->
          <span class="btn" @click="show">立即预约</span>
        </div>
        <div class="jj">
          <p class="namejj"><i class="el-icon-s-custom"></i>{{detail.hospitalExpert.name}}医生简介</p>
          <p v-html="detail.hospitalExpert.description"></p>
        </div>
        <!--<div class="gg">-->
          <!--<p>PETCT检查</p>-->
          <!--<div class="b">-->
            <!--<ul>-->
              <!--<li>>PETCT引领分子诊治肿瘤时代</li>-->
              <!--<li>>什么是18F-FDG >P</li>-->
              <!--<li>>PET/CT可以鉴别肿瘤的分期吗</li>-->
              <!--<li>>广州中山六院PETCT优势表现有哪些</li>-->
              <!--<li>>PETCT检查为什么要空腹？</li>-->
              <!--<li>>上海哪些人适合做PETCT检查？</li>-->
              <!--<li>>什么是PETCT检查 </li>-->
              <!--<li> >做PET-CT检查需注意哪些？</li>-->
            <!--</ul>-->
            <!--<img src="../../assets/image/leftad2.png" alt="">-->
          <!--</div>-->
        <!--</div>-->
      </div>
      <div class="r">
        <div class="top">
          <div class="lT">
            <ul class="list">
              <li class="active">热门PETCT/MR专家 <p></p></li>
            </ul>
          </div>
          <ul class="lB">
            <li v-for="item in detail.hospitalExpertList" :key="item.id" @click="zjxq(item.id)">
              <img :src="item.picUrl" alt="">
              <div>
                <h3>{{item.name}}</h3>
                <p>{{item.sellPoint}}</p>
                <p>￥{{item.salesPrice}}</p>
              </div>
            </li>
          </ul>
        </div>
        <!--<div class="b">-->
          <!--<p>扫描下方二维码咨询在线客服</p>-->
          <!--<img src="../../assets/image/rwm1.png" alt="">-->
          <!--<p>微信扫一扫</p>-->
        <!--</div>-->
      </div>
      <el-dialog
        :title="title"
        :visible.sync="dialogVisible"
        width="30%">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="预约日期" prop="appointmentTime">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="ruleForm.appointmentTime"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              style="width: 100%;"
            >
            </el-date-picker>

          </el-form-item>
          <el-form-item label="姓名" prop="name">
            <el-input v-model="ruleForm.name" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="ruleForm.phone" placeholder="请输入手机号码"></el-input>
          </el-form-item>
          <el-form-item label="身份证号" prop="idCard">
            <el-input v-model="ruleForm.idCard" placeholder="请输入身份证号码"></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="sex">
            <el-radio-group v-model="ruleForm.sex">
              <el-radio label="男"></el-radio>
              <el-radio label="女"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="糖尿病" prop="isDm">
            <el-radio-group v-model="ruleForm.isDm">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="病情" prop="remark">
            <textarea v-model="ruleForm.remark" placeholder="请输入病情描述，50字以内" style="width: 100%; height: 100px;padding: 10px" maxlength="50"></textarea>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submit">立即提交</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  // import commonTable from '@/components/commonTable.vue'
  import server from '@/service/server.js'
export default {
    name: 'index',
  components: {
    // commonTable
  },
    data () {
        return {
          title: '',
          detail: {
            hospitalExpert: {
              picUrl: '',
              name: '',
              salesPrice: '',
              sellPoint: '',
              description: ''
          }
          },
          dialogVisible: false,
          id: "",
          ruleForm: {
            appointmentTime: '',
            name: '',
            phone: '',
            idCard: '',
            isDm: '',
            sex: '',
            remark: '',
            category: '1'
          },
          rules: {
            department: [
              { required: true, message: '请输入检测部位', trigger: 'blur' }
            ],
            idCard: [
              { required: true, message: '请输入身份证号码', trigger: 'blur' }
            ],
            name: [
              { required: true, message: '请输入姓名', trigger: 'blur' }
            ],
            phone: [
              { required: true, message: '请输入手机号', trigger: 'blur' }
            ],
            remark: [
              { required: true, message: '请输入', trigger: 'blur' }
            ],
            appointmentTime: [
              { required: true, message: '请选择日期', trigger: 'change' }
            ],
            sex: [
              { required: true, message: '请选择', trigger: 'change' }
            ],
            isDm: [
              { required: true, message: '请选择', trigger: 'change' }
            ]
          }
        }
    },
    methods: {
      show() {
        this.dialogVisible = true
      },
      zjxq(id){
        this.$router.push({
          path: `/zjxq?id=${id}`
        })
      },
      submit() {
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            this.ruleForm.sex = this.ruleForm.sex == '男' ? '1' : '0'
            this.ruleForm.isDm = this.ruleForm.isDm == '是' ? '1' : '0'
            this.ruleForm.modelId =  this.id
            this.ruleForm.modelName = this.detail.hospitalExpert.name
            this.ruleForm.salesPrice = this.detail.hospitalExpert.salesPrice
            server.order(this.ruleForm).then((res) => {
              if (res.code === 200) {
                this.$message({
                  message: '预约成功',
                  type: 'success'
                });
                this.dialogVisible = false
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    },
  created(){
    this.id = this.$route.query.id
  },
    mounted(){
      server.expertInfo(this.id).then((res) => {
        console.log(res.data)
        this.detail = res.data
        this.title = `在线预约：推荐专家【${this.detail.hospitalExpert.name}】`
      })
      document.documentElement.scrollTop = 0;
    }

}
</script>
<style lang="scss" scoped>
  .container {
    /deep/ .el-dialog__footer{
      text-align: center;
      .el-button--primary {
        background-color: #CB0E07;
        border: none;
      }
    }
    .divR{
      width: calc(100% - 0px);
      margin-left: auto;
      overflow: hidden;
      p{
        font-size: 18px;
        /*font-family: Adobe Kaiti Std;*/
        font-weight: normal;
        color: #000000;
        line-height: 21px;
        margin-bottom: 15px;
      }
      .btn{
        width: 100px;
        height: 40px;
        background: #CB0E07;
        border-radius: 6px;
        float: right;
        font-size: 14px;
        color: #FFFFFF;
        text-align: center;
        line-height: 40px;
        cursor: pointer;
      }
    }
    width: 1370px;
    margin: 0 auto;
    .title {
      padding: 10px 20px;
      background-color: #FFFFFF;
      margin: 20px 0;
      font-size: 16px;
      span {
        color: #5288F0;
      }
    }
    .neir{
      display: flex;
      .l{
        width: 1010px;
        .t{
          display: flex;
          img{
            width: 236px;
            height: 236px;
          }
          div{
            width: calc(100% - 250px);
            margin-left: auto;
            p{
              font-size: 14px;
              color: #333;
              margin-bottom: 20px;
              span{
                font-size: 16px;
                color: #000;
              }
            }
            .name{
              font-size: 18px;
              color: #000;
            }
            .zc{
              font-size: 24px;
              color: rgba(203, 14, 7, 1);
              font-style: italic;
            }
          }
        }
        .jj{
          border-bottom: 1px solid rgba(218, 214, 214, 1);
          padding-bottom: 10px;
          p{
            font-size: 20px;
            /*font-family: Adobe Heiti Std;*/;
            font-weight: normal;
            color: #000000;
            line-height: 44px;
          }
          .namejj{
            font-size: 24px;
            /*font-family: Adobe Heiti Std;*/;
            font-weight: normal;
            color: #CB0E07;
            line-height: 44px;
            margin: 20px auto 10px;
          }
        }
        .gg{
          width: 100%;
          border: 1px solid #E1E3EA;
          box-shadow: 0px 3px 7px 0px rgba(35,24,21,0.35);
          margin: 10px auto 30px;
          padding: 20px;
          margin-bottom: 150px;
          p{
            font-size: 18px;
            /*font-family: Adobe Heiti Std;*/;
            font-weight: normal;
            color: #B2ABAA;
          }
          .b{
            display: flex;
            width: 100%;
            margin-top: 20px;
            ul{
              display: flex;
              flex-wrap: wrap;
              width: calc(100% - 300px);
              li{
                width: 50%;
                font-size: 19px;
                /*font-family: Adobe Kaiti Std;*/
                font-weight: normal;
                color: #31AACD;
                cursor: pointer;
              }
            }
            img{
              width: 243px;
              height: 172px;
              margin-left: auto;
              margin-right: 20px;
            }
          }

        }
      }
      .r{
        width: calc(100% - 1030px);
        margin-left: 20px;
        .top{
         width: 100%;
          /*height: 73%;*/
          background: #FFFFFF;
          border: 2px solid #EAEBEB;
          .lT{
            width: 100%;
            .list{
              margin-bottom: 10px;
              li{
                text-align: center;
                cursor: pointer;
                font-size: 19px;
                /*font-family: Adobe Heiti Std;*/;
                font-weight: normal;
                color: #000000;
                line-height: 33px;
                padding-top: 10px;
                p{
                  width: 97px;
                  height: 4px;
                  background: rgba(0, 180, 247, 0);
                  margin: 10px auto 0;
                }
              }
              li.active{
                p{
                  background: rgba(0, 180, 247, 1);
                }
              }
            }
          }
          .lB{
            width: 100%;
            padding: 0 20px;
            li{
              border-bottom: 1px solid rgba(209, 213, 213, 1);
              display: flex;
              margin-bottom: 20px;
              cursor: pointer;
              &:hover {
                img {
                  transform: scale(1.1);
                }
              }
              img{
                width: 100px;
                height: 100px;
                transition: all 0.5s;
              }
              div{
                padding: 4px 0;
                margin-left: 10px;
                width: calc(100% - 140px);
                h3{
                  font-size: 20px;
                  /*font-family: Adobe Heiti Std;*/;
                  font-weight: normal;
                  color: #000000;
                  width: 100%;
                  overflow:hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }
                p:nth-child(3){
                  color: rgba(203, 14, 7, 1);
                  font-size: 16px;
                }
                p{
                  font-size: 14px;
                  /*font-family: Adobe Heiti Std;*/;
                  font-weight: normal;
                  color: #B7BEBE;
                  /*line-height: 32px;*/
                  overflow:hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  margin: 10px 0;
                }
              }
            }
          }
        }
        .b{
          width: 323px;
          border: 1px solid #E1E3EA;
          box-shadow: 0px 3px 7px 0px rgba(35,24,21,0.35);
          border-radius: 15px;
          margin-top: 30px;
          margin-left: 10px;
          padding: 20px;
          box-sizing: border-box;
          p:nth-child(1){
            font-size: 21px;
            /*font-family: Adobe Heiti Std;*/;
            font-weight: normal;
            color: #000000;
            text-align: center;
            border-bottom: 1px solid rgba(210, 214, 214, 1);
            padding-bottom: 10px;
          }
          img{
            width: 150px;
            height: 150px;
            display: block;
            margin: 10px auto;
          }
          p:nth-child(3){
            font-size: 21px;
            /*font-family: Adobe Heiti Std;*/;
            font-weight: normal;
            color: #000000;
            text-align: center;
          }
        }
      }
    }
  }
  @media (max-width: 750px) {
    .container {
      width: 100%;
      margin-top: 60px;
      .divR .btn {
        display: none;
      }
      .neir {
        display: block;
        padding: 15px;
        background-color: #FFFFFF;
        .l {
          width: 100%;
          .t {
            img {
              width: 120px;
              height: 120px;
            }
            div {
              width: calc(100% - 130px);
              .zc {
                font-size: 16px;
              }
              p {
                margin-bottom: 10px;
              }
              .sc {
                line-height: 24px;
              }
            }
          }
        }
        .r {
          display: none;
        }
      }
    }
  }
</style>
